import React from "react";

export function TactLoader({ label = "LOADING" }) {
  return (
    <div className="font-mono text-[#7C3AED] tact-pulse text-sm tracking-widest" data-testid="tact-loader">
      [ {label} ... ]
    </div>
  );
}

export function SectionTitle({ children, kicker, className = "", testId }) {
  return (
    <div className={`mb-8 ${className}`} data-testid={testId}>
      {kicker && (
        <div className="font-mono text-[10px] uppercase tracking-[0.3em] text-[#71717A] mb-2">
          {kicker}
        </div>
      )}
      <h2 className="font-heading text-3xl sm:text-4xl lg:text-5xl uppercase tracking-wider text-[#09090B] dark:text-[#F4F4F5]">
        {children}
      </h2>
    </div>
  );
}

export function Panel({ children, className = "", testId, accent = false }) {
  return (
    <div
      data-testid={testId}
      className={`bg-[#FFFFFF] dark:bg-[#1A1A1E] border border-[#E4E4E7] dark:border-[#2A2A30] ${accent ? "border-t-2 border-t-[#7C3AED]" : ""} p-6 ${className}`}
    >
      {children}
    </div>
  );
}

export function StatBadge({ label, value, testId, highlight = false }) {
  // EA FC / FUT-style premium stat tile: layered gradient fill, glossy top
  // highlight, inset ring, oversized condensed value and contrast label.
  const base = highlight
    ? "bg-gradient-to-br from-[#7C3AED] via-[#5B21B6] to-[#1E0B3A] border-[#7C3AED]/70"
    : "bg-gradient-to-br from-[#1C1C22] via-[#141418] to-[#09090B] border-white/10";
  const valueColor = highlight
    ? "text-white drop-shadow-[0_0_14px_rgba(0,255,135,0.4)]"
    : "text-[#00FF87] drop-shadow-[0_0_10px_rgba(0,255,135,0.35)]";
  const labelColor = highlight ? "text-white/80" : "text-white/65";
  return (
    <div
      data-testid={testId}
      className={`relative overflow-hidden border ${base} px-5 py-4 rounded-[2px] shadow-[0_10px_28px_-8px_rgba(0,0,0,0.55),inset_0_1px_0_rgba(255,255,255,0.12)]`}
    >
      {/* Glossy top highlight — FUT card sheen */}
      <span
        className="pointer-events-none absolute inset-x-0 top-0 h-1/2 bg-gradient-to-b from-white/15 to-transparent"
        aria-hidden
      />
      {/* Corner chevron accent */}
      <span
        className="pointer-events-none absolute -top-6 -right-6 w-16 h-16 rotate-45 bg-[#00FF87]/12"
        aria-hidden
      />
      <div className="relative">
        <span className={`font-mono text-[9px] uppercase tracking-[0.3em] block ${labelColor}`}>
          {label}
        </span>
        <span
          className={`font-score text-2xl sm:text-3xl leading-none block mt-1 ${valueColor}`}
        >
          {value}
        </span>
      </div>
    </div>
  );
}
